/**
 * Подгрузка HTML-контента по пунктам меню (Главная, О стратегии, Об авторе, Дашборд, Админка).
 * Работает на любой странице с #content-area и data-content-base (например /content/home).
 */
document.addEventListener('DOMContentLoaded', function () {
  const contentArea = document.getElementById('content-area');
  if (!contentArea) return;

  const contentBase = contentArea.dataset.contentBase;
  if (!contentBase) return;

  const firstPageId = contentArea.dataset.firstPageId;
  const menuLinks = document.querySelectorAll('.nav-link[data-page-id]');

  function loadContent(pageId) {
    if (!pageId) return;
    contentArea.innerHTML = '<p class="text-muted">Загрузка...</p>';
    fetch(contentBase + '/' + encodeURIComponent(pageId))
      .then(function (res) {
        if (!res.ok) return res.text().then(function (t) { throw new Error(t || res.status); });
        return res.text();
      })
      .then(function (html) {
        contentArea.innerHTML = html;
        // Скрипты, вставленные через innerHTML, не выполняются — запускаем инлайн-скрипты вручную
        var scripts = contentArea.querySelectorAll('script');
        scripts.forEach(function (script) {
          if (script.src) return; // внешние уже на странице (Plotly) или не нужны
          var el = document.createElement('script');
          el.textContent = script.textContent;
          contentArea.appendChild(el);
        });
        if (window.updateThemePNGs) window.updateThemePNGs();
        if (typeof window.Plotly !== 'undefined' && window.dispatchEvent) {
          window.dispatchEvent(new Event('themechanged'));
        }
      })
      .catch(function (err) {
        // Сообщение видно и в светлой, и в тёмной теме (alert-warning)
        var msg = err.message || '';
        if (msg.indexOf('<') !== -1) {
          contentArea.innerHTML = msg;
        } else {
          contentArea.innerHTML = '<div class="alert alert-warning" role="alert"><strong>Не удалось загрузить контент.</strong> ' + (msg ? ' ' + msg : '') + '</div>';
        }
      });
  }

  menuLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      menuLinks.forEach(function (l) { l.classList.remove('active'); });
      link.classList.add('active');
      var pageId = link.dataset.pageId;
      if (pageId) loadContent(pageId);
    });
  });

  if (firstPageId) {
    loadContent(firstPageId);
    var firstLink = document.querySelector('.nav-link[data-page-id="' + firstPageId + '"]');
    if (firstLink) firstLink.classList.add('active');
  }
});
